export const MONTH_LABELS = [
  "Jan",
  "Fév",
  "Mar",
  "Avr",
  "Mai",
  "Juin",
  "Juil",
  "Aoû",
  "Sep",
  "Oct",
  "Nov",
  "Déc",
] as const;

export function startOfDay(d: Date): Date {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}

export function formatDayLabel(d: Date): string {
  return d.toLocaleDateString("fr-FR", { weekday: "short", day: "numeric" });
}

export function isSameDay(a: Date, b: Date): boolean {
  return a.toDateString() === b.toDateString();
}

export function isSameMonth(a: Date, b: Date): boolean {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth();
}

export interface BreakdownPoint {
  name: string;
  value: number;
}

export interface DayFlowPoint {
  label: string;
  date: string;
  inflows: number;
  outflows: number;
}

export interface RevenueDayPoint {
  label: string;
  date: string;
  revenue: number;
  documents: number;
}

export interface RevenueMonthPoint {
  label: string;
  month: string;
  revenue: number;
}
